import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

import { initFacebookSdk } from './_helpers';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

// initFacebookSdk().then(bootstrapApp);
initFacebookSdk().then();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  environment: process.env.NODE_ENV,
  integrations: [new BrowserTracing()],
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  debug: false,
});

function bootstrapApp() {
  ReactDOM.render(
    <React.Fragment>
      <App />
    </React.Fragment>,
    document.getElementById('root')
  );
}

bootstrapApp();
